import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
    selector: 'input[numbersOnly]',
})
export class NumbersonlyDirective {
    constructor(private _el: ElementRef) {}
    @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
        const inputValue = event.key;
        const controlValue = this._el.nativeElement.value;
        if (!/^[0-9]$/.test(inputValue) || controlValue.length > 3) {
            event.preventDefault();
        }
    }
}
